/* eslint-disable */
function init() {
    const $modal = $('#account-modal');

    // Toggle modal visibility on account icon click
    $('#account-icon, #m-account-show').click(function (event) {
        if ($(this).attr('id') === 'account-icon') {
            event.preventDefault(); // Prevent default action if necessary
            $modal.toggle();
        }
    
        var user = dataLayer.find(o => o.user != null).user;
        dataLayer.push({
            'event': 'custom_event',
            'eventCategory': 'top_navigation',
            'eventAction': 'top_navigation_account_click',
            'eventLabel': 'Signin/Register',
            'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
            'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
            'screenName': 'Top navigation',
            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
            'userId': user.user_id != '' ? user.user_id : ''
        });
    });

    // Close modal when clicking outside
    $(document).click(function (event) {
        if (!$(event.target).closest('#account-icon, #account-modal').length) {
            $modal.hide();
        }
    });

    //header account logout click
    $('.header-logout').click(function (event) {
        var user = dataLayer.find(o => o.user != null).user;
        dataLayer.push({
            'event': 'custom_event',
            'eventCategory': 'my_account',
            'eventAction': 'logout',
            'eventLabel': 'logout',
            'country': window.GlobalAttributes.COUNTRY,
            'language': window.GlobalAttributes.LANGUAGE,
            'screenName' : 'Top navigation',
            "userType": user.user_id!='' ? 'logged-in' : 'logged-out',
            "userId": user.user_id!='' ? user.user_id : ''
        });
    });
}

module.exports = {
    init: init
};



// WEBPACK FOOTER //
// ./cartridges/app_boggi_core/cartridge/js/pages/account.js